export default __webpack_public_path__ + "static/media/Glowimg1.44ed4b43.png";